import type { TNetworkError } from '@/services/errors';
import type { TCounterRowDTO } from './counters.dto';

import { BaseService } from '@/services/api';
import { errorUtils } from '@/services/errors';

import type { TCounters } from './counters.types';

import { toCounters } from './counters.adapters';

class CountersService extends BaseService {
  protected readonly serviceName = 'countersService';

  public async readCounters(): Promise<TCounters | TNetworkError> {
    const rows = await this.runList(
      this.db.rpc('staff_counters').returns<TCounterRowDTO[]>(),
      'readCounters',
    );

    if (errorUtils.isNetworkError(rows)) {
      return rows;
    }

    return toCounters(rows.rows);
  }
}

const countersService = new CountersService();

export {
  countersService,
};
